import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import LOGO from "../assets/images/logo.png";
import { POST, alert, loading } from "../components/CustomComponent";

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(circle at top right, rgba(47, 213, 228, 0.20), transparent 32%), linear-gradient(160deg, #eef6f9 0%, #dbeaf1 55%, #edf7fb 100%)",
};

const cardStyle = {
  width: "100%",
  maxWidth: 460,
  background: "rgba(255,255,255,0.92)",
  border: "1px solid rgba(255,255,255,0.6)",
  borderRadius: 28,
  boxShadow: "0 28px 60px rgba(8, 46, 78, 0.14)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
};

const inputStyle = {
  borderRadius: 18,
  border: "1px solid #b8d2e8",
  backgroundColor: "#ffffff",
  color: "#072845",
};

// หน้าตั้งรหัสผ่านใหม่ เข้าจากลิงก์ในอีเมล /reset-password?token=xxxx
export default function ResetPassword() {
  const navigate = useNavigate();
  const token = useMemo(() => new URLSearchParams(window.location.search).get("token") || "", []);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [done, setDone] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password.length < 8) {
      await alert("", "warning", "แจ้งเตือน", "รหัสผ่านใหม่ต้องยาวอย่างน้อย 8 ตัวอักษร");
      return;
    }
    if (password !== confirmPassword) {
      await alert("", "warning", "แจ้งเตือน", "รหัสผ่านใหม่และการยืนยันไม่ตรงกัน");
      return;
    }

    loading(true);
    const result = await POST("v1/auth/reset-password", { token, password: btoa(password) });
    loading(false);

    if (result?.status) {
      setDone(true);
    } else {
      await alert("", "warning", "แจ้งเตือน", result?.message || "ลิงก์ไม่ถูกต้องหรือหมดอายุแล้ว");
    }
  };

  return (
    <section className="d-flex align-items-center justify-content-center px-3 py-5" style={pageStyle}>
      <div className="p-4 p-md-5" style={cardStyle}>
        <div className="text-center mb-4">
          <img src={LOGO} alt="ParthenonTech" style={{ height: 52, objectFit: "contain" }} />
        </div>

        {!token ? (
          <div className="text-center">
            <div className="fw-bold mb-2" style={{ color: "#0b2c4c", fontSize: "1.25rem" }}>ลิงก์ไม่ถูกต้อง</div>
            <div className="text-secondary small mb-4">ไม่พบโทเคนสำหรับตั้งรหัสผ่านใหม่ กรุณาขอลิงก์ใหม่อีกครั้ง</div>
            <button className="btn btn-primary px-4 rounded-3" onClick={() => navigate("/")}>กลับไปหน้าเข้าสู่ระบบ</button>
          </div>
        ) : done ? (
          <div className="text-center">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{ width: 64, height: 64, borderRadius: 20, background: "rgba(47, 181, 114, 0.14)", color: "#188251", fontSize: 26 }}
            >
              <i className="fa-solid fa-circle-check" />
            </div>
            <div className="fw-bold mb-2" style={{ color: "#0b2c4c", fontSize: "1.25rem" }}>ตั้งรหัสผ่านใหม่เรียบร้อย</div>
            <div className="text-secondary small mb-4">เข้าสู่ระบบด้วยรหัสผ่านใหม่ได้ทันที</div>
            <button className="btn btn-primary px-4 rounded-3" onClick={() => navigate("/")}>ไปหน้าเข้าสู่ระบบ</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="fw-bold mb-1" style={{ color: "#0b2c4c", fontSize: "1.4rem" }}>ตั้งรหัสผ่านใหม่</div>
            <div className="text-secondary small mb-4">ตั้งรหัสผ่านใหม่ให้บัญชีของคุณ อย่างน้อย 8 ตัวอักษร</div>

            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ color: "#0b2c4c" }}>รหัสผ่านใหม่</label>
              <input
                type="password"
                className="form-control"
                style={inputStyle}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="••••••••"
                autoComplete="new-password"
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold" style={{ color: "#0b2c4c" }}>ยืนยันรหัสผ่านใหม่</label>
              <input
                type="password"
                className="form-control"
                style={inputStyle}
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                placeholder="••••••••"
                autoComplete="new-password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 fw-semibold py-3"
              style={{ borderRadius: 18 }}
              disabled={!password || !confirmPassword}
            >
              บันทึกรหัสผ่านใหม่
            </button>

            <button type="button" className="btn btn-link w-100 mt-2 text-decoration-none" onClick={() => navigate("/")}>
              กลับไปหน้าเข้าสู่ระบบ
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
